import { Box, IconButton, useTheme } from "@mui/material";
import { useContext } from "react";
import { ColorModeContext, tokens } from "../../theme";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import { useAuth } from "../../hooks/useAuth";

const Topbar = ({ onMenuClick, isMobile }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    // Navigate is handled automatically by ProtectedRoute
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        p: 2,
        position: "sticky",
        top: 0,
        backgroundColor: colors.primary[400],
        zIndex: 2,
        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
      }}
    >
      <Box display="flex" alignItems="center">
        {isMobile && (
          <IconButton
            onClick={onMenuClick}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Box
          sx={{
            display: "flex",
            backgroundColor: colors.primary[400],
            borderRadius: "3px",
            maxWidth: { xs: "160px", sm: "300px", md: "400px" },
          }}
        >
          <InputBase
            sx={{
              ml: 2,
              flex: 1,
              fontSize: { xs: "0.875rem", sm: "1rem" },
            }}
            placeholder="Search"
          />
          <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>

      <Box display="flex" alignItems="center" gap={{ xs: 0.5, sm: 1, md: 2 }}>
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton sx={{ display: { xs: "none", sm: "inline-flex" } }}>
          <NotificationsOutlinedIcon />
        </IconButton>
        <IconButton sx={{ display: { xs: "none", sm: "inline-flex" } }}>
          <SettingsOutlinedIcon />
        </IconButton>
        <IconButton>
          <PersonOutlinedIcon />
        </IconButton>
        <IconButton onClick={handleLogout}>
          <LogoutIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Topbar;
